module.exports = __webpack_public_path__ + "img/yellow.7e49ce20.svg";